import React from 'react';
import cx from 'classnames';

import { locale } from '@trqk/utils';

interface ProductLogoProps {
    product: TrqkProduct;
    size?: 'sm';
}

export const ProductLogo = ({
    product,
    size = 'sm',
}: ProductLogoProps): JSX.Element | null => {
    const productName = locale.enUS.PRODUCTS[product];

    if (productName === undefined) {
        return null;
    }

    return (
        <span
            className={cx('font-semibold', {
                'text-base': size === 'sm',
            })}
        >
            Trqk
            <span className="text-tertiary-400">{productName}</span>
        </span>
    );
};
